import Plan from '@/orm/models/Account/Plan';
import { computed } from '@vue/composition-api';

// TODO: remove mock
const mock = {
  data: [{
    id: 2,
    quotas: [{
      itemType: 'interviews',
      type: 'temp',
      value: 50,
    }, {
      itemType: 'calls',
      type: 'temp',
      value: 250,
    }, {
      itemType: 'sms',
      type: 'temp',
      value: 250,
    }],
    price: {
      value: 100,
      currency: 'RUB',
    },
    title: 'Small business',
    description: null,
  }, {
    id: 3,
    quotas: [{
      itemType: 'interviews',
      type: 'temp',
      value: 100,
    }, {
      itemType: 'calls',
      type: 'temp',
      value: 1000,
    }, {
      itemType: 'sms',
      type: 'temp',
      value: 1000,
    }],
    price: {
      value: 100,
      currency: 'RUB',
    },
    title: 'wdwadwad',
    description: null,
  }, {
    id: 4,
    quotas: [{
      itemType: 'interviews',
      type: 'temp',
      value: 250,
    }, {
      itemType: 'calls',
      type: 'temp',
      value: 2500,
    }, {
      itemType: 'sms',
      type: 'temp',
      value: 2500,
    }],
    price: {
      value: 100,
      currency: 'RUB',
    },
    title: 'wdwadwd',
    description: null,
  }, {
    id: 5,
    quotas: [{
      itemType: 'interviews',
      type: 'temp',
      value: 1000,
    }, {
      itemType: 'calls',
      type: 'temp',
      value: 5000,
    }, {
      itemType: 'sms',
      type: 'temp',
      value: 5000,
    }],
    price: {
      value: 100,
      currency: 'RUB',
    },
    title: 'Mass',
    description: null,
  }],
};

export default function usePlan() {
  const plans = computed(() => Plan.all());

  function sortPlans() {
    return Plan.query()
      .orderBy((plan) => plan?.price?.value || 0)
      .get();
  }

  const sortedPlans = computed(() => sortPlans());

  const plansWithoutDefault = computed(() => plans.value.filter((p) => {
    return !!p.price;
  }));

  async function fetchAll() {
    try {
      await Plan.api()
        .fetchAll();
    } catch (e) {
      await Plan.insert(mock);
    }
  }

  function getPlanById(id) {
    return plans.value?.find((plan) => plan.id === id);
  }

  return {
    plans,
    plansWithoutDefault,
    fetchAll,
    getPlanById,
    sortedPlans,
  };
}
